 export const project = [
    {
       "id":1,
       "Project-Name":"Fingerprint Attendance System (2018)",
       "Team":" Shweta Dalal, Yukta Behare",
       "Description":"The door unlocking and attendance system is proposed for maintaining record of attendance including the exact date and time by taking fingerprint impressions from the RNXGians at the time of entry and exit and storing all the data in such a way that we can access it any time. Withal at the time of entry if the impression gets matched then the door automatically gets unlocked ",
        "img":"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQia0B5ZLYPDKg6QvG5WvHLzMO8IvhCFfqRng&usqp=CAU",
        "controls":false
      }
    ,
    {
      "id":2,
       "Project-Name":"LED Cube (2018)",
       "Team":" Shweta Dalal",
       "Description":"LED cube utilizes code based off of instructables designer,CHR and uses an Arduino to power the cube and act as programmer,This cube gives of a warm glow that is pleasant to the eye and will entertain people of all ages",
       "img":"https://hackster.imgix.net/uploads/attachments/1145135/_WqskeceGZg.blob?auto=compress%2Cformat&w=900&h=675&fit=min",
       "controls":false
      }
    ,
    {
      "id":"3",
       "Project-Name":"Quad Copter(2017,2018,2019)",
       "Team":"Amar Tupat, Datta Dhore, Shubham Jagtap ",
       "Description":"A Quadcopter is a small remote-controlled aircraft like a helicopter, with four blades that spin rapidly to push air downwards thus creating a thrust for keeping the body aloft. All these blades are coplanar spinning in the opposite direction. A quadcopter is a type of drone which can be controlled by a remote or made fully automated. It is a light machine made for achieving high speed and agility. It has a high potential for performing various tasks that are dangerous to humans and costly. It has a wide range of applications like Aerial Photography & Videography, Payload carrying, Roof cleaning and drone racing.",
     "img":"https://www.mydronelab.com/wp-content/uploads/2016/04/DIY-Quadcopter-810x539.jpg?ezimgfmt=ng%3Awebp%2Fngcb1%2Frs%3Adevice%2Frscb1-2",
     "video":"https://ik.imagekit.io/wqweoudym/VID20190301182546_EWohcj5T8.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1657818153123",
     "controls":true
      }
    ,
    {
      "id":4,
       "Project-Name":"RC Car with Camera(2018)",
       "Team":"Amar Tupat, Datta Dhore",
       "Description":"A RC bot with camera was made to examine the bottom part of railways and detection of IED, bomb or any explosion over there.In this project we had used Arduino as a main controller radio frequency controller. Input is being taking by using camera and displayed on camera.",
       "img":"https://hackster.imgix.net/uploads/attachments/997002/uploads2ftmp2f8badf908-93ab-4600-813f-74ed2194cc052fimg_20190928_144046_741_5YfYMpnQ2v.jpg?auto=compress%2Cformat&w=900&h=675&fit=min",
       "controls":false
    }
    ,
    {
      "id":5,
       "Project-Name":"RC Plane (2018,2019)",
       "Team":"Amar Tupat ,Payal Warthi, Kshitiji Sagar,Sarang Dondal, Datta Dhore, Yukta Behare",
       "Description":"A radio controlled plane (RC Plane) is a small flying machine i.e. controlled by an operator on the ground using a hand held transmitter. The plane is controlled using a transmitter communicating with a receiver sending signals to servos onboard the plane. The aerodynamics governing these aircrafts is the same as those governing large aircrafts. The aircraft considered in this study was designed to have optimum lift and drag characteristics. This was achieved by choosing the optimum values of fuselage length, wingspan, elevator, rudder dimensions and the all up weight determined by a series of iterative analysis. The RC plane has a wide range of commercial applications like it can be used for studying and implementing the different aspects of aero-modelling, photography and videography, payload caring, etc.",
       "img":"https://content.instructables.com/ORIG/FSE/ULV9/IOA9JCUV/FSEULV9IOA9JCUV.jpg?auto=webp",
       "controls":false
    }
    ,
    {
      "id":6,
       "Project-Name":"Lab Automation(2018)",
       "Team":"Shankar Biradar, Swaraj Shingote, Paresh Shahare, Swarupa Bawaskar, Pratiksha Deshpande.",
       "Description": "Its to automate the lab to save electricity and to decrease human efforts. Remotely access has given on web server and can be switched on or off the devices bt sending message or by calling to gsm.",
       "img":"https://hackster.imgix.net/uploads/attachments/1151663/_KMOCRayNjs.blob?auto=compress&w=900&h=675&fit=min&fm=jpg",
       "controls":false
    }
    ,
    {
      "id":7,
       "Project-Name":"Pick and place Robotic arm(2018)",
       "Team":"Om Singh,Yukta Behere, Shruti Kulkarni ",
       "Description": "Robotic arm mounted on remote controlled bot used for pick and place task, smooth working and degree of freedom was ensured using servo and gear mechanism. Servo  enables, wrist and fingers and 45 degree , 90 degree and 180 degree movement of shoulder(base). ",
       "img":"https://hackster.imgix.net/uploads/attachments/1269217/_s0OSff4vGv.blob?auto=compress%2Cformat&w=900&h=675&fit=min",
       "controls":false
    }
    ,
    {
      "id":8,
       "Project-Name":"Wheelchair Cum Stretcher (2017)",
       "Team":"Bhusan Katade, Shriniwas Adhe, Pratiksha Bhosle, Kshitij Sagar, Vishal Kayande  ",
       "Description": "In hospitals there is a need to shift patient from wheelchair to stretcher them stretcher to bed and vice versa.So it becomes very difficult for that patient as well as person with him to shift mant times. So to overcome this problem we have to overcome this problem we have develop a  solution which converts from wheelchair to stretcher and by fixing the wheels it also used as a bed. So, it becomes easier for both of them and help to reduce the pain of patient  slightly.",
       "img":"https://www.seminarsonly.com/Engineering-Projects/Mechanical/awc1.jpg",
       "controls":false
    }
    ,
    {
      "id":9,
       "Project-Name":"Line follower + Pick & Place + Shortest Path(2018,2019)",
       "Team":"Paresh Shahare, Aayush singh, Laxmikat Suryavanshi, Ratik Zade, Shubham Jagtap, Aseet Dhale, Abhijeet Jadhav ",
       "Description":"Line Follower → A robot which uses lines as its path to reach a specific destination.Technology Used → Arduino, Microcontroller Algorithms Implemented → Shortest Path, PID Control. Awards → Secured 1st Rank at BITS ATMOS (PILANI) 2018 in Line Follower Reached Semi-Finals E-Yantra 2018 (the same stack used) Stage-2 IARC IIT-Kanpur (Techkriti)",
       "img":"https://hackster.imgix.net/uploads/attachments/338200/img_7848_-_copy_AduA9iET16.JPG?auto=compress%2Cformat&w=900&h=675&fit=min",
       "controls":false
    }
    ,
    {
      "id":10,
       "Project-Name": "Anti-Theft device for four Wheeler(2018)",
       "Team":"Shweta Dalal , Dipka Kurhade, Ankita Mankar",
       "Description": "Vehicle theft has increased in recent years. These vehicles may incur huge losses on the amount invested on them so it's necessary to create such system that will prevent vehicle  theft.The main intention of the system is to prevent the vehicle from getting stolen and if it is then find out the exact location of the stolen vehicle and inform it to the concerned auth",
       "img":"https://img.etimg.com/thumb/msid-78363248,width-640,resizemode-4,imgsize-129181/alarms.jpg",
       "controls":false
    }
   ,
   {
      "id":11,
      "Project-Name": "Battery Management System For LIPO(Battery)",
      "Team":"Kshitij Kiran Sagar , Shruti Sunil Kulkarni, Komal Ankush Kuntewad",
      "Description": "BMS continuously counts the voltage of each cell in the battery. When the battery crosses discharging or charging voltage limit then MOSFET will act as a switch and it will disconnect the contact between the battery and the respective load. Also, it will give an indication of when the battery is charged or discharged. ON/OFF switch is also provided as Battery Saver()",
      "img":"https://m.media-amazon.com/images/I/61kSV8RnvCL._SY355_.jpg",
      "controls":false
   }
  ,
  {
   "id":12,
   "Project-Name": "Live Bus Tracking(2017)",
   "Team":"Mrunal Joshi , Satyajit Lande, Satyajit Lande",
   "Description": "The motive behind the creation of this project is minimization of waiting period at the bus stops. The project is expected to provide accurate location of the bus in real time and the corresponding route. As a result, the cases of late arrival of bus and students missing the bus will reduce drastically.",
   "img":"https://nextpittsburgh.com/wp-content/uploads/2014/06/real-time-bus-tracking-750x400.jpg",
   "controls":false
}
,
{
   "id":13,
   "Project-Name": "Person Counting using Opencvs(2017)",
   "Team":"Aayush Singh , Laxmikant Suryavanshi",
   "Description": "An image processing based tool used to count people traversing in or out Deployable on Rasberry Pi. We used open CV's background subtractor MOG for this purpose.",
   "img":"https://149695847.v2.pressablecdn.com/wp-content/uploads/2020/04/aim_image.png",
   "controls":false

}
,
{
   "id":14,
   "Project-Name": "Voltage and Current sensor(2019)",
   "Team":"Kshitij Kiran Sagar , Shruti Sunil Kulkarni",
   "Description": "Vehicle theft has increased in recent years. These vehicles may incur huge losses on the amount invested on them so it's necessary to create such system that will prevent vehicle  theft.The main intention of the system is to prevent the vehicle from getting stolen and if it is then find out the exact location of the stolen vehicle and inform it to the concerned auth",
   "img":"https://content.instructables.com/ORIG/FQQ/66Z3/KIZZZOY6/FQQ66Z3KIZZZOY6.jpg?auto=webp&frame=1&crop=3:2&width=320&md=536e0e1d489b60f57dccdb6ced5aba59",
   "controls":false
}
,
{
   "id":15,
   "Project-Name": "Rover Design",
   "Team":"Jagdish Patil , Nipun Dhandage, Pragati Darekar",
   "Description": "This project is been performed for representing SGGSIE&T at University River Challenge organized by Mars Society. The purpose of the Rover is to study the soil and atmospheric compositions, gathering images of the surfaces, undergo surveillance and must be able to perform other typical tasks like pick and place, obstacles avoiding, studing the surface and environment. The project is still under its research and development phase.",
   "img":"https://images.newscientist.com/wp-content/uploads/2020/03/05190305/mars2020_rover_web.jpg",
   "controls":false
}
,
{
   "id":16,
   "Project-Name": "VR MEETING ROOMS",
   "Team":" Sakshi Kulkarni, Shweta Nere, ",
   "Description": "We aspire to develop a Cross-Platform 3D incubation center for startups/students with all the advanced features like special rooms for each group with facilities of video conferencing, smartboards, live programming/simulation, live interaction with mentors and other groups. There will be a bulletin board that will display the upcoming hackathons, current schemes, and opportunities for startups. Also, it will display information about vacant rooms, online members, and the availability of mentors.",
   "img":"https://res.cloudinary.com/practicaldev/image/fetch/s--eLL4v6dL--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://39296.cdn.cke-cs.com/xnX5w1TWo7hQQOywFbkx/images/5598bd6c586752a615e03f8bc7909f8047e9b2e4c02003fe.png/w_1350",
   "controls":false
}
,
{
   "id":17,
   "Project-Name": "Mobile Application to Order from the Vendors During Pandemic",
   "Team":" Pratik Thakur, Amit Choudhary, Vedang Fate, Vrushabh Bhagwatkar, Viren Bhosale",
   "Description": "It all begun with analysing different problems faced by the people during the pandemic and during the lockdown. And we finally narrowed down to the most commonly faced problem, to frequently go out and don't know if the shop is open or not and the particular thing is available or not.",
   "img":"https://images.citizenmatters.in/wp-content/uploads/sites/2/2020/04/29111522/Corona-apps-1024x438.jpeg",
   "controls":false
}
,
{
   "id":18,
   "Project-Name": "Online Task(Online simulation project )",
   "Team":" Jagdish Patil, Manasvi Walekar, Pagati Darekar, Shrikant Solanke, Nipun Dhandage, Chetan Patil",
   "Description": "Second year students have mentored their juniors through an online platform. They have taught about electronics software. They have given online tasks with the time limitation. All tasks have been evaluated by all expert seniors.",
   "img":"https://pmi.hu/static/uploaded/Files/Blog/board-view-in-meistertask-project-management.png",
   "controls":false
},
{
   "id":19,
   "Project-Name": "Robotic arm for stroked patient and GFR Device",
   "Team": " Arbaz Khan, Pratiksha Gunjal, Jayteerth Ralegankar, Saurav Kharat",
   "Description": "GFR (Glove Finger Rehabilitation) Device is designed for patients suffering from strokes from arduino , by using this device patients can take daily massage treatment without frequent assistance from therapist and in the worst case if it is unable to rehabilitate then they are able to control their stroked hand by the another hand.",
   "Github":"https://github.com/khan212515/Glove-Finger-Rehabilitation",
   "img":"https://ik.imagekit.io/wqweoudym/IMG_20220325_094621_rRH07joEW.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651772118508",
   "video":"https://ik.imagekit.io/wqweoudym/WhatsApp_Video_2022-08-07_at_5.32.12_PM_L6zLnSjKs.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1659972912935",
   "controls":true

},{
   "id":20,
   "Project-Name": "SGGS Nexus",
   "Team":" Adwait Bokade, Shailesh Deshmukh, Gauri Katti, Dhammadip Kamble",
   "Pdf":"https://drive.google.com/file/d/11p7mt9fNWpHFKLVoPv_pbRSynA1nR2OF",

   "Description": "“Nexus” is a Web Application which helps community to have a social connectivity within their groups. This app enables users to have their profile, and they can add posts, images, videos, quotes, captions to their feed.It is a Social Media app which contains the basic social medium features to enhance the ability similar to any other social media applications ongoing worldwide.",
   "img":"https://ik.imagekit.io/wqweoudym/nexus_91mNLkgfS.png?ik-sdk-version=javascript-1.4.3&updatedAt=1657878975928",
   "video":"https://ik.imagekit.io/wqweoudym/Nexus?ik-sdk-version=javascript-1.4.3&updatedAt=1657821505829",
   "controls":true
},
{
   "id":21,
   "Project-Name": "Smart Lock",
   "Team":"Shailesh Deshmukh, Adwait Bokade, Ishwar Gade",
   "Pdf":"https://drive.google.com/file/d/18Q81Bk8Xj_nnbBzmjE8tbkrNGglV_E6k",

   "Description": "The Smart Lock Device’s working is straightforward. In simple words, the user must enter the correct pin to unlock the device. If the entered pin is incorrect, a buzzer ring. In both cases the user is notified about the actions taken by the device. It also has a built-in L.C.D to display various messages.",
   "img":"https://ik.imagekit.io/wqweoudym/smart_lock_eDCIxq9by.png?ik-sdk-version=javascript-1.4.3&updatedAt=1657808402832",
   "video":"https://ik.imagekit.io/wqweoudym/smart.lock?ik-sdk-version=javascript-1.4.3&updatedAt=1657874626428",
   "controls":true
},
{
   "id":22,
   "Project-Name": "Live Locate",
   "Team":"Shailesh Deshmukh, Adwait Bokade",
   "Pdf":" ",
   "Github":"https://github.com/adwait12345/Liveocate",
   "Description": "With the help of live locate we will track your location and speed and will provide alert when you exceed your certain speed limit(Only for mobile Devices)",
   "img":"https://ik.imagekit.io/wqweoudym/livelocate_iem_Y1XBK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1657809210348",
   "video":"https://ik.imagekit.io/wqweoudym/Livelocate_2US_5eXHi.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1657813593395",
   "controls":true
},
{
   "id":23,
   "Project-Name": "Subscribing via email",
   "Team":"Adwait Bokade",
   
   "Github":"https://github.com/adwait12345/GrowthScribe",
   "github-visiblity":true,
   "Description": "User gets registered as a subscriber , and get stored in database which an be accesed via explore user. For this project A rest api is built and hosted on heroku which can be accessed any where",
   "img":"https://ik.imagekit.io/wqweoudym/Screenshot__0H_66DCRh.png?updatedAt=1657823007113&tr=w-1574,h-886,fo-custom,cm-extract",
   "video":"https://ik.imagekit.io/wqweoudym/2022-07-03_23-34-27_afS7ttfD0.mp4?ik-sdk-version=javascript-1.4.3&updatedAt=1657822516986",
   "controls":true
},{
   "id":23,
   "Project-Name": "Smart Blind Stick (Istick)",
   "Team":"Aashutosh Karale,Mayur Vaidya,Kapil Kapse ",
   "Pdf":"https://drive.google.com/file/d/1STJadELldgVBwORzGdGGvg8B9ceJFk0e",
   "Github":"https://github.com/Aashutosh-922/Istick-using-IOT",
   "github-visiblity":true,
   "Description": "This project provides the best solution for the mobility difficulties of blind people, by which they can easily mobilize themselves, be a successful part of society, easily earn their living",
   "img":"https://ik.imagekit.io/wqweoudym/Preview_of__Bat_Cane_Helps_The_Blind_See__Biomimicry__G5GzwQnEC.png?ik-sdk-version=javascript-1.4.3&updatedAt=1659866519876",
   "controls":false
},{
   "id":23,
   "Project-Name": "Android Application RCR",
   "Team": " Sanket Wakde , Umaan Khan,  Suchit Gourkhede, Aashutosh Karale",

   "Pdf":"https://ik.imagekit.io/wqweoudym/Android_Team_Project_Report_RkBQMVHpD.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1668976860995",
   "Github":"https://github.com/Aashutosh-922/Component_Register_RNXG-RCR-",
   "github-visiblity":true,
   "Description": "RNXGians have developed an application that will replace the paperwork of Registering Component and Maintaining records that will be helpful for the Database Management and will help the Team To keep track of all the things",
   "img":"https://ik.imagekit.io/wqweoudym/Screenshot_2022-11-16-00-41-15-542_com.example.rcr30_KaZKe2_5B.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668977277053",
   "controls":false
},{
   "id":23,
   "Project-Name": "Alcohol Detection Device Using Arduino",
   "Team": " Varad Vilasrao Patil,Sarthak Sanjiv  Khandare,Shweta Umesh Khune",
   "github-visiblity": false,

   "Pdf":"https://ik.imagekit.io/wqweoudym/Varad_50h2mnCj9.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1669014315770",
   "Description": "In Public transport it is need to test driver’s health and mental condition that all passengers has to be safe and it will enforcement can be effective in the drink and drive cases.",
   "img":"https://ik.imagekit.io/wqweoudym/IMG-20220328-WA0017_acQ468l-j.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1669014339963",
   "controls":false
},
]
export let projects = project.reverse()
